import { LineageService } from '@/api/services/LineageService';
import { LineageEntityDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getLineageDownstreamTool: ToolDefinition = {
  name: 'get_lineage_downstream',
  description: 'Get downstream lineage (what depends on asset). Use for downstream dependencies, consumers, outputs, "what depends on X?", or impact analysis. Requires URN; use search_assets first if only name provided. Returns array of downstream assets: name, id, urn, type.',
  input_schema: {
    type: 'object',
    properties: {
      urn: {
        type: 'string',
        description: 'Asset URN. Use search_assets first if only name provided.',
      },
    },
    required: ['urn'],
  },
};

/**
 * Execute the get_lineage_downstream tool
 */
export async function executeGetLineageDownstream(
  params: { urn: string },
): Promise<Array<LineageEntityDto> | { error: string }> {
  try {
    const result = await callWithContext('sifflet-ai-chat', () => LineageService.getLineageDownstreamsByUrn({
      urn: params.urn,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getLineageDownstreamTool;
